module.exports = __webpack_public_path__ + "img/area_5.ef0c5378.png";